import React from 'react';
import MainPage from '../../../composents/MainPage';
import resources from '../../../services';
import DataTable from '../../../composents/DataTable';

const methods = [
	{
		value: 'GET',
		label: 'Read all',
	},
	{
		value: 'POST',
		label: 'Create',
	},
	{
		value: 'PUT',
		label: 'Update',
	},
	{
		value: 'DELETE',
		label: 'Delete',
	},
	{
		value: 'activate_deactivate',
		label: 'activate/deactivate',
	},
	{
		value: 'top_up',
		label: 'top up',
	},
	{
		value: 'details',
		label: 'details',
	},
];

const title = 'Permissions';
const headers = {
	icon: 'feather icon-user',
	title: title,
	description: 'track and manage all permissions information',
};

export default function PermissionPage() {
	return (
		<MainPage headers={headers} show_search>
			<DataTable
				column={[
					{ label: 'Title', field: 'title' },
					{
						label: 'Type of permission',
						field: 'type',
					},
					{
						label: 'Category',
						field: 'group',
					},
					{
						label: 'Method',
						field: 'method',
						renderStyle: (el) => {
							const found = methods.filter(
								(e) => e.value === el.method
							);

							if (found.length > 0) {
								return found[0].label;
							}
						},
					},
				]}
				resource={resources.permission}
				title={title}
				link="/administrators/permissions"
			/>
		</MainPage>
	);
}
